import { useEffect } from 'react';

import { confluenceLocalStorageInstance as localStorage, keys } from '@confluence/storage-manager';
import { useIsLivePagesFeatureEnabled } from '@confluence/live-pages-utils/entry-points/useIsLivePagesFeatureEnabled';
import { expVal } from '@confluence/feature-experiments';

/**
 * This component is used to expose the Modernization AA experiment.
 * It does not render anything.
 */
export const InitModernizationAaExp = () => {
	const hasInitializedModernizationGa = localStorage.getItem(keys.LIVE_DOCS_HAS_EXPOSED_AA_EXP);
	const { isLivePagesFeatureEnabled } = useIsLivePagesFeatureEnabled();

	useEffect(() => {
		if (hasInitializedModernizationGa || isLivePagesFeatureEnabled) {
			return;
		}
		if (expVal('confluence_modernization_aa_exp', 'cohort', 'not-enrolled') !== 'not-enrolled') {
			localStorage.setItem(keys.LIVE_DOCS_HAS_EXPOSED_AA_EXP, 'true');
		}
	}, [hasInitializedModernizationGa, isLivePagesFeatureEnabled]);

	return null;
};
